import React, { useEffect, useState } from 'react';
import CustomModal from '../../components/CustomModal/CustomModal';
import useMediaQuery from '../../hooks/useMediaQuery';
import CustomTable from '../../components/CustomTable/CustomTable';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import { alertService } from '../../services/AlertService';
import UtilityService from '../../services/UtillityServices/UtilityService';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import { ACTION_TYPES } from '../../model/actions';
import useCertificazioniConfigTable from '../../configTable/useCertificazioniConfigTable';
import CertificazioneManagerForm from '../../components/Forms/CertificazioneManagerForm/CertificazioneManagerForm';
import useCertificazioni from '../../hooks/useCertificazioni';

const GestioneCertificazioniPage = () => {
  const {
    getCertificazioniByParams,
    loadingStateCertificazioni,
    createCertificazione,
    deleteCertificazione,
    modalStateCertificazioni,
    setModalStateCertificazioni,
    updateCertificazione,
  } = useCertificazioni();

  const isWideScreen = useMediaQuery('(min-width: 1200px)');
  const [certificazioni, setCertificazioni] = useState([]);
  const [selectedCertificazione, setSelectedCertificazione] = useState(null);
  const [formCreateCertificazione, setFormCreateCertificazione] = useState({});

  const [orderBy, setOrderBy] = useState(null);
  const [orderType, setOrderType] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1); 
  const [formDataFilter, setFormDataFilter] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingCertificazioni, setIsLoadingCertificazioni] = useState(false);
  const certificazioniConfigTable = useCertificazioniConfigTable();

  useEffect(() => {
    if (!isLoadingCertificazioni) {
      printAllCertificazioni();
    }
  }, [orderBy, orderType, selectedPage]);
  
  const fetchCertificazioni = async (obj) => {
    setIsLoadingCertificazioni(true);
  
    obj = {
      ...obj,
      filtri: {
        ...obj.filtri,
      }
    };
  
    const fetchCertificazioniList = await getCertificazioniByParams(obj);
    const countPagination = Math.ceil(fetchCertificazioniList?.count / obj.limite);
    let certificazioniList = fetchCertificazioniList?.data ?? [];
    setTotalPages(countPagination);
    setCertificazioni(certificazioniList);
    setIsLoadingCertificazioni(false);
    if(certificazioniList?.length === 0){
      setSelectedPage(1)
    }
  }
  
  const printAllCertificazioni = async () => {
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: selectedPage ?? 1,
      ordinamento: `${orderBy ?? "descrizione"} ${orderType ?? "asc"}`
    };
  
    await fetchCertificazioni(obj);
  };
  
  const onFilteredTable = async () => {
    setSelectedPage(1);
  
    let obj = {
      filtri: {
        ...formDataFilter,
      },
      limite: 10,
      pagina: 1,
      ordinamento: `${orderBy ?? "descrizione"} ${orderType ?? "asc"}`
    };
  
    await fetchCertificazioni(obj);
  };

  const openInfoModal = (certificazione) => {
    setSelectedCertificazione(certificazione)
    setModalStateCertificazioni(state => ({ ...state, showModalInfoCertificazione: true }));
  }

  const openEditModal = (certificazione) => {
    setSelectedCertificazione(certificazione)
    setFormCreateCertificazione(certificazione);
    setModalStateCertificazioni(state => ({ ...state, showModalUpdateCertificazione: true }));
  }

  const openDeleteModal = (certificazione) => {
    setSelectedCertificazione(certificazione)
    setModalStateCertificazioni(state => ({ ...state, showModalDeleteCertificazione: true }));
  }

  const handleCloseModal = () => {
    setModalStateCertificazioni(state => ({ 
       ...state,
       showModalCreateCertificazione: false, 
       showModalInfoCertificazione: false, 
       showModalDeleteCertificazione: false,
       showModalUpdateCertificazione: false,
      }));
  }

  const openModalCreateCertificazione = () => {
    setModalStateCertificazioni(state => ({ ...state, showModalCreateCertificazione: true }));
  }

  const renderSelectedDeleteCertificazione = () => {
    return (
      <>
      <span className="d-block fs-4 mb-2"><b>Vuoi eliminare la seguente certificazione?</b> </span>
      <span className="d-block fs-5">{selectedCertificazione?.descrizione}</span>
      </>
    )
  }

  const onCreateCertificazione = async () => {
    const requiredFields = ["descrizione"];
    const missingFields = UtilityService.validationForm(formCreateCertificazione, requiredFields);
    if (missingFields?.length > 0) {
        alertService.warn(`I seguenti campi sono obbligatori: ${missingFields}`, {autoClose: true});
        return;
    }

  const res = await createCertificazione(formCreateCertificazione);
    if(res) {
      printAllCertificazioni();
    }

  };

  const onDeleteCertificazione = async () => {
    const obj = {id_certificazione: selectedCertificazione?.id_certificazione}
    const res = await deleteCertificazione(obj);
    if(res) {
      printAllCertificazioni();
    }
  }

  const onUpdateCertificazione = async () => {
    const obj = {
      ...formCreateCertificazione,
      id_certificazione: selectedCertificazione?.id_certificazione
    }
    const res = await updateCertificazione(obj);
    if(res) {
      printAllCertificazioni();
    }
  }

  const handleOrder = (orderBy, orderType) => {
    setOrderBy(orderBy);
    setOrderType(orderType);
  };

  const handlePageChange = (page) => {
    setSelectedPage(page);
  };

  const actions = [
    {
      label: ACTION_TYPES.UPDATE,
      icon: 'bi-pencil-fill text-warning',
      tooltip: ACTION_TYPES.UPDATE,
      type: ACTION_TYPES.MANAGER,
      condition: () => true,
      onClick: (certificazione) => openEditModal(certificazione)
    },
    {
      label: ACTION_TYPES.DELETE,
      icon: 'bi-trash-fill text-danger',
      tooltip: ACTION_TYPES.DELETE,
      type: ACTION_TYPES.MANAGER,
      condition: () => true,
      onClick: (certificazione) => openDeleteModal(certificazione)
    }
  ];

  return (
    <>
        <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`} style={{minHeight: '700px'}}>
            <div className='container'>
              <div className='d-flex justify-content-between custom-card-header'>
                <div className='d-flex gap-3 custom-card-title my-2'>
                  <div className={`custom-icon-container`}>
                    <i className={`bi custom-icon bi-award fs-2`}></i>
                  </div>
                  <div className='align-self-center'>
                    <span className='fs-4 d-block'><i><b>Gestione certificazioni</b></i></span>
                  </div>
                </div>
                <div className='align-self-center my-2'>
                  <button type='button' className='btn btn-primary' onClick={openModalCreateCertificazione}>Crea certificazione</button>
                </div>
              </div>
              <div className='mt-5'>
                <CustomFilterTable 
                  formDataFilter={formDataFilter}
                  setFormDataFilter={setFormDataFilter}
                  onFilteredTable={onFilteredTable}
                  isLoadingData={loadingStateCertificazioni.isLoadingCertificazioniByParams}
                  searchNodeType={[
                    {nodeType: "input", name: "descrizione", placeholder: "Certificazione"},
                  ]}
                />
              </div>
              {  !loadingStateCertificazioni.isLoadingCertificazioniByParams ? ( 
                  <>
             {(!certificazioni || certificazioni?.length === 0) ? (
                    <div className='mt-5 pt-5 text-center'>
                        <p>Non ci sono certificazioni da mostrare.</p>
                    </div>) : (
                      <>
              <CustomTable
                data={certificazioni}
                actions={actions}
                columns={certificazioniConfigTable}
                handleOrder={handleOrder}
                orderBy={orderBy}
                orderType={orderType}
              />
              <div className="d-flex justify-content-end mt-1">
                <CustomPagination
                  totalPages={totalPages}
                  selectedPage={selectedPage}
                  handlePageChange={handlePageChange}
                />
              </div>
                      </>

                    )}
                  </>
              ) : (
                <LoadingTable loadingCol={2} />
              ) }
              <>
              </>
            </div>
        </div>
         <CustomModal
          show={modalStateCertificazioni.showModalCreateCertificazione}
          onHide={handleCloseModal}
          headerText="Crea certificazione"
          size={"md"}
          btnText={"Crea certificazione"}
          body={<CertificazioneManagerForm 
            formCertificazioneManager={formCreateCertificazione}
            setFormCertificazioneManager={setFormCreateCertificazione}
            showModalCertificazioneManager={modalStateCertificazioni.showModalUpdateCertificazione}
          />} 
          isLoading={loadingStateCertificazioni.isLoadingCertificazioneCreating}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onCreateCertificazione} 
        />
         <CustomModal
          show={modalStateCertificazioni.showModalUpdateCertificazione}
          onHide={handleCloseModal}
          headerText="Modifica certificazione"
          size={"md"}
          btnText={"Salva modifiche"}
          body={<CertificazioneManagerForm 
            formCertificazioneManager={formCreateCertificazione}
            setFormCertificazioneManager={setFormCreateCertificazione}
            showModalCertificazioneManager={modalStateCertificazioni.showModalUpdateCertificazione}
          />} 
          isLoading={loadingStateCertificazioni.isLoadingCertificazioneUpdate}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onUpdateCertificazione} 
        />
         <CustomModal
          show={modalStateCertificazioni.showModalDeleteCertificazione}
          onHide={handleCloseModal}
          headerText="Elimina certificazione"
          size={"md"}
          variant={"danger"}
          btnText={"Elimina"}
          body={renderSelectedDeleteCertificazione()} 
          isLoading={loadingStateCertificazioni.isLoadingCertificazioneDelete}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onDeleteCertificazione} 
        />
      </>
  )

}

export default GestioneCertificazioniPage;

